import { LearnerPageChrome } from "@/pages/learners/page-chrome"
import { SaveButton } from "@/components/shared/action-buttons"
import { PageBody } from "@/components/ui/layout"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { LearnersSchoolsSchoolProfileForm } from "@/types/serializers"
import { useId } from "react"
import { formSchema } from "./form-schema"
import { useNavigate, usePathParam, useProps } from "@/lib/page-rendering"

type EditProps = {
  school: LearnersSchoolsSchoolProfileForm
}

const useEditProps = () => useProps<EditProps>()
export default function Page() {
  const navigate = useNavigate()
  const school_id = usePathParam("schoolId")
  const formId = useId()

  const { school } = useEditProps()
  const handleSubmit = (data: any) => {
    navigate({
      href: `/learners/schools/${school_id}/school_profile`,
      method: "patch",
      data: data,
    })
  }

  return (
    <>
      <LearnerPageChrome action={<SaveButton form={formId} />} />
      <PageBody>
        <FormRenderer
          schema={formSchema}
          formId={formId}
          onSubmit={handleSubmit}
          defaultValues={{ school }}
        />
      </PageBody>
    </>
  )
}
